import { render } from "./types.vue?vue&type=template&id=16d48272&scoped=true&ts=true"
import script from "./types.vue?vue&type=script&lang=ts"
export * from "./types.vue?vue&type=script&lang=ts"

import "./types.vue?vue&type=style&index=0&id=16d48272&lang=less&scoped=true"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d48272"]])

export default __exports__